// extracted by mini-css-extract-plugin
module.exports = {"insightsWrapper":"insights-teaser-list_insightsWrapper__9XBgx"};